import React, { useEffect, useState, useRef } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { ASSET_URL } from '../../env/Configurations';
import './Custom-Document-Viewer.scss';
import { S3_TYPE } from '../../constants/CommonConst';

const CustomDocumentViewer = ({ document, title }) => {
  const [fileUrl, setFileUrl] = useState('');
  const [safeBlobUrl, setSafeBlobUrl] = useState('');
  const [open, setOpen] = useState(false);
  const [viewerError, setViewerError] = useState('');
  const blobUrlRef = useRef(null);

  useEffect(() => {
    if (!document) return;
    const url = document?.type === S3_TYPE ? `${ASSET_URL}${document?.url}` : document?.url;
    setFileUrl(url);
  }, [document]);

  useEffect(() => {
    if (!open && blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
      blobUrlRef.current = null;
      setSafeBlobUrl('');
      setViewerError('');
    }
  }, [open]);

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
    };
  }, []);

  const handleOpen = async () => {
    if (document?.type !== S3_TYPE) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } else {
      setOpen(true);
      setViewerError('');
      setSafeBlobUrl('');

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
          throw new Error('Failed to load document.');
        }
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));

        // Revoke any previous blob URL
        if (blobUrlRef.current) {
          URL.revokeObjectURL(blobUrlRef.current);
        }
        blobUrlRef.current = blobUrl;
        setSafeBlobUrl(blobUrl);
      } catch (err) {
        setViewerError('This file cannot be displayed due to security restrictions.');
      }
    }
  };

  return (
    <div className='custom-document-viewer'>
      <div className='document-card' onClick={handleOpen}>
        <img
          className='image-card'
          src={
            document?.type !== S3_TYPE
              ? '/assets/img/link_black_24dp.svg'
              : '/assets/img/description_black_36dp.svg'
          }
          alt='open document'
        />
        <p className='doc-title'>{title}</p>
      </div>
      {document?.type === S3_TYPE && (
        <Dialog
          className='document-viewer'
          open={open}
          onClose={() => setOpen(false)}
          maxWidth='lg'
          fullWidth
        >
          <DialogContent className='document-viewer-content'>
            <Cancel className='document-viewer-close' onClick={() => setOpen(false)} />
            {viewerError ? (
              <p className='doc-error'>{viewerError}</p>
            ) : safeBlobUrl ? (
              <iframe
                className='pdf-iframe'
                src={safeBlobUrl}
                title={title || 'Document Preview'}
              />
            ) : (
              <p className='doc-error'>Loading document...</p>
            )}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CustomDocumentViewer;
